<template lang='pug'>
  form#login(autocomplete="off", @submit.prevent="login" method="post")
    .img-container
      img.logo(src="@/assets/logo.png")
    b-form-group
      h1 {{ $t('login.login') }}
      span Ingresa tus datos y comienza la aventura.

    b-form-group
      vm-input(icon='email-outline', :placeholder='$t("login.email")' v-model="form.email" required autofocus type="email")
      span.help-block(v-if='authError')
        strong {{ $t('auth.failed') }}

    b-form-group
      vm-input(type="password" icon='lock-outline' :placeholder='$t("login.password")' v-model="form.password" required pass)

    b-form-group#boxes
      .d-flex.justify-content-between
        vm-checkbox(v-model='form.rememberMe') {{ $t('login.keep_connected') }}

        router-link.content-vertical.text-secondary(to='/admin/password/reset') {{ $t('login.forgot_password') }}

    b-form-group
      vm-button#loginButton.vm-con-loading__container(color="primary", type="filled", width="100%") {{ $t('login.login') }}
</template>

<script>
import vmFacebook from '@/components/buttons/vm-facebook'
import vmGoogle from '@/components/buttons/vm-google'
import formValidation from '@/utils/formValidations'
import { mapActions } from 'vuex'

export default {
  name: 'login',
  components: {
    vmFacebook,
    vmGoogle
  },
  data () {
    return {
      form: {
        email: null,
        password: null,
        rememberMe: true
      },
      authError: false
    }
  },
  methods: {
    ...mapActions({
      loadData: 'loadData',
      setAlertMessage: 'setAlertMessage'
    }),
    async doLogin () {
      await this.$auth.login({
        data: this.form,
        success (response) {
          const { status } = response
          if (status === 401) {
            this.authError = true
          } else if (status === 403) {
            this.$router.push({ name: 'admin.verification.notice', params: { user_id: response.data.id, email: this.form.email } })
          } else {
            this.loadData()
          }
        },
        rememberMe: this.form.rememberMe,
        redirect: '/admin'
      }).catch(error => {
        this.setAlertMessage({ color: 'danger', title: 'errors.connection_error', text: error.response.data.original.message })
      })
    },
    async socialAuth (payload) {
      await this.$auth.login({
        url: '/auth/' + payload.provider + '/callback',
        params: {
          token: payload.response.accessToken
        },
        success (response) {
          const { status } = response
          if (status === 401) {
            this.authError = true
          }
          this.loadData()
        },
        rememberMe: this.form.rememberMe,
        redirect: '/admin/'
      }).catch(error => {
        this.setAlertMessage({ color: 'danger', title: 'errors.connection_error', text: error.response.data.original.message })
      })
    },
    async login (evt) {
      if (!formValidation(evt)) return
      this.$vm.loading({
        background: 'primary',
        color: '#fff',
        container: '#loginButton',
        scale: 0.45
      })
      try {
        await this.doLogin()
      } catch (error) {
        this.setAlertMessage({ color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' })
      }
      this.$vm.loading.close('#loginButton > .con-vm-loading')
    }
  }
}
</script>

<style lang="scss" scoped>
.img-container {
  width: 100%;
  text-align: center;
  margin-bottom: 30px;
}
.logo {
  width: 150px;
}

@media only screen and (max-width: 768px) {
  #loginButton {
    width: 100%;
  }
  #login {
    margin-top: 30px;
  }
  .msg {
    text-align: center;
  }
}
#loginButton {
  width: 100%;
}
.msg {
  text-align: center;
  margin-top: 10px;
}
.social {
  display: flex;
  justify-content: space-around;
}
.vm-input {
  color: #5b5777;
  .vm-input--icon {
    color: rgba(0,0,0,.4) !important;
  }
}
@media only screen and (max-width: 768px) {
  #loginButton {
    width: 100%;
  }
  .msg {
    text-align: center;
    margin-top: 10px;
  }
}
</style>
